import { Injectable } from '@angular/core';
import swal from 'sweetalert2';
import { AccountService } from '@app/core/account/services/account.service';
import { EMPTY, Observable, of } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class AccountAccessGuardService {
  private currentAccount: any;

  constructor(private accountService: AccountService) {
    this.accountService.account$.subscribe(account => {
      this.currentAccount = account;
    });
  }

  isRestricted(): boolean {
    const account = this.currentAccount;
    if (!account || !account.id) {
      return; // Do nothing if account is undefined
    }
    const restricted = account && (account.deactivated && !account.active) || (!account.deactivated && !account.active);
    return restricted;
  }

  showRestrictionAlert(): void {
    const account = this.currentAccount;
  
    if (!account || !account.id) {
      return; // Do nothing if account is undefined
    }
  
    let message = '';
  
    if (account && account.deactivated && !account.active) {
      message = 'This action is not allowed. The account is deactivated.';
    } else if (account && !account.deactivated && !account.active) {
      message = 'This action is not allowed. The account is locked.';
    }
  
    if (message) {
      swal('Access Denied', message, 'warning');
    }
  }
  
  accountGuardRestriction<T>(operation: () => Observable<T>): Observable<T> {
    if (this.isRestricted()) {
      this.showRestrictionAlert();
      return of(null);
    }
    return operation();
  }
  accountGuardRestrictionAction(callback: () => void): void {
    if (this.isRestricted()) {
      this.showRestrictionAlert();
      return;
    }
    callback();
  }
}
